import React, { useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import { scrollToTop } from '../Shared/ScrollOnTop';
const ManageMonth = () => {
   
    return (
        <>
          <nav className={`navbar navbar-expand-lg navbar-module MenuSticky`}>
                <div className="container-fluid">
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav m-auto">
                            {/* <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/MonthlyTasks/StartNewMonth">Start New Month</NavLink>
                            </li> */}
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/MonthlyTasks/StartNewMonthChallan">Start New Month</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/MonthlyTasks/SingleStudentMonthlyChallan">Single Challan</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/MonthlyTasks/ManageMonth">Manage Month</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink onClick={scrollToTop} className="nav-link" to="/MonthlyTasks/FeeAbstractReport">Fee Abstract</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default ManageMonth;
